console.log("Gift Wrap XHR Interceptor Loaded");

document.addEventListener("DOMContentLoaded", () => {
  const checkbox = document.querySelector("#gift-wrap-checkbox");

  if (!checkbox) {
    console.warn("Gift Wrap checkbox not found");
    return;
  }

  console.log("Gift Wrap checkbox FOUND");

  // Save original XHR send method
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function (body) {
    try {
      // Intercept ONLY Add to Cart
      if (this._url && this._url.includes("/cart/add")) {
        console.log("🚨 Intercepting XHR Add to Cart request");

        if (checkbox.checked) {
          console.log("🎁 Adding Gift Wrap via XHR");

          // Case 1: body is FormData
          if (body instanceof FormData) {
            body.append("properties[Gift Wrap]", "Yes (+₹99)");
          }

          // Case 2: body is JSON string
          else if (typeof body === "string") {
            try {
              let json = JSON.parse(body);

              if (Array.isArray(json.items)) {
                json.items = json.items.map(item => ({
                  ...item,
                  properties: {
                    ...(item.properties || {}),
                    "Gift Wrap": "Yes (+₹99)"
                  }
                }));
              } else {
                json.properties = {
                  ...(json.properties || {}),
                  "Gift Wrap": "Yes (+₹99)"
                };
              }

              body = JSON.stringify(json);
            } catch (err) {
              console.error("JSON parse error", err);
            }
          }
        }
      }
    } catch (e) {
      console.error("Gift wrap XHR error:", e);
    }

    // Continue with original send
    return originalSend.call(this, body);
  };

  console.log("🎁 Gift Wrap XHR Interceptor ACTIVE");
});

// Intercept XHR open() to capture URL
const originalOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url) {
  this._url = url;
  return originalOpen.apply(this, arguments);
};
